import { useTranslation } from "react-i18next";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { SectionEyebrow } from "./SectionEyebrow";
import { ShieldCheck, Sparkle, Certificate, Heartbeat, HandHeart, Clock } from "@phosphor-icons/react";

const ICONS = [ShieldCheck, Sparkle, Certificate, Heartbeat, HandHeart, Clock];

const Item = ({ Icon, title, desc, i }) => {
  const { ref, inView } = useScrollReveal({ threshold: 0.15 });
  return (
    <div
      ref={ref}
      data-testid={`differential-${i}`}
      style={{ animationDelay: `${i * 80}ms` }}
      className={`reveal ${inView ? "in-view" : ""} p-8 lg:p-10 group hover:bg-[#A7CA99]/5 transition-colors flex flex-col items-center text-center`}
    >
      <div className="w-14 h-14 flex items-center justify-center bg-[#A7CA99]/15 group-hover:bg-[#A7CA99]/30 transition-colors rounded-sm">
        <Icon size={28} weight="thin" className="text-[#3E5239]" />
      </div>
      <h3 className="mt-6 font-serif text-xl lg:text-2xl font-normal text-[#3E5239]">{title}</h3>
      <p className="mt-3 text-sm font-light text-[#6B7A66] leading-relaxed max-w-[28ch]">{desc}</p>
    </div>
  );
};

export const Differentials = () => {
  const { t } = useTranslation();
  const items = t("differentials.items", { returnObjects: true });

  return (
    <section id="diferenciais" data-testid="differentials-section" className="py-24 lg:py-36 bg-[#F6F5F2]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <SectionEyebrow num="07">{t("differentials.eyebrow")}</SectionEyebrow>
          <h2 data-testid="differentials-headline" className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light tracking-tight leading-[1.05] text-[#3E5239]">
            {t("differentials.title_l1")}
            <br />
            <span className="italic text-[#A7CA99]">{t("differentials.title_l2")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#E4E2DA]">
          {items.map((it, i) => (
            <div key={it.title} className="border-r border-b border-[#E4E2DA] -ml-px -mt-px">
              <Item Icon={ICONS[i]} title={it.title} desc={it.desc} i={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
